import React from 'react';
import {
  ContentStyle,
  RedirectSection,
  SuccessImgStyle,
  SuccessStyledContainer,
} from './SuccessScreen.styled';
import { Link } from 'react-router-dom';
import { PAGE_URL } from '../../../config/appConfig';

const SuccessScreen = () => {
  return (
    <SuccessStyledContainer>
      <div className='flexStyle container'>
        <SuccessImgStyle>
          <img
            src='/images/LandingPagesImages/success.png'
            className='imgStyle'
          />
        </SuccessImgStyle>
        <ContentStyle>
          <h2>Thank you for contacting us</h2>
          <h5>Our team will reach out to you within the next 24 hours</h5>
        </ContentStyle>
        <RedirectSection>
          <h2>Not looking for eCommerce shipping? Checkout</h2>
          <div className='linkSection'>
            <Link to={`${PAGE_URL.SERVICES_B2C}`} className='linkStyle'>
              B2C Logistics
            </Link>
            <div style={{ color: '#b0b0b0' }}>|</div>
            <Link to={`${PAGE_URL.SERVICES_B2B}`} className='linkStyle'>
              B2B Logistics
            </Link>
            <div style={{ color: '#b0b0b0' }}>|</div>
            <Link to={`${PAGE_URL.SERVICES_CBL}`} className='linkStyle'>
              International Logistics
            </Link>
            <div style={{ color: '#b0b0b0' }}>|</div>
            <Link to={`${PAGE_URL.SERVICES_TPL}`} className='linkStyle'>
              Third Party Logistics
            </Link>
          </div>
        </RedirectSection>
      </div>
    </SuccessStyledContainer>
  );
};

export default SuccessScreen;
